import {Content} from "#/src/pages/(auth)/reset-password/Content";

export {Page}

function Page() {
  return <div className={"h-100"}><Content/></div>
}
